/**
 * Dependencies.
 */

import createResourceReducer from 'store/utils/createResourceReducer'
import { actionTypes } from 'store/actions/resources/orders'

/**
 * Order reducer.
 */

export default createResourceReducer({ actionTypes })
